<div
  :class="[
    'container-fluid proba-layout-shell vh-100 d-flex flex-column overflow-hidden px-0',
    is_sidebar_hidden ? 'layout-sidebar-hidden' : 'layout-sidebar-open'
  ]"
>
  <!-- Navbar -->
  <navbar
    v-if="should_show_layout_topbar"
    @toggle-sidebar="toggle_sidebar"
    class="proba-topbar p-2 sticky-top bg-white z-3 border-bottom"
  />

  <header
    v-if="is_dwypd_recruitment_domain"
    class="dwypd-mobile-account-bar"
  >
    <div class="dwypd-mobile-account-brand">
      <img :src="$clientLogo" alt="DWYPD" class="dwypd-mobile-account-logo">
    </div>
    <div class="dwypd-mobile-account-control">
      <button
        type="button"
        class="dwypd-mobile-account-button"
        :aria-expanded="dwypd_account_menu_open ? 'true' : 'false'"
        aria-controls="dwypd-mobile-account-menu"
        aria-label="Open account menu"
        @click="toggle_dwypd_account_menu"
      >
        <span class="dwypd-mobile-account-avatar">{{ dwypd_account_initial }}</span>
      </button>
      <div
        v-if="dwypd_account_menu_open"
        id="dwypd-mobile-account-menu"
        class="dwypd-mobile-account-menu"
        role="menu"
      >
        <div class="dwypd-mobile-account-summary">
          <span class="dwypd-mobile-account-avatar is-menu-avatar">{{ dwypd_account_initial }}</span>
          <div class="dwypd-mobile-account-user">
            <strong>{{ dwypd_account_name }}</strong>
            <span>{{ dwypd_account_role }}</span>
          </div>
        </div>
        <button
          type="button"
          class="dwypd-mobile-account-signout"
          role="menuitem"
          @click="logout_dwypd_account"
        >
          <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  </header>

  <!-- Content Area -->
  <div class="row g-0 position-relative proba-layout-body flex-grow-1 overflow-hidden">
  <!-- Sidebar -->
  <div
    :class="[
      'proba-sidebar-col sidebar-col col-md-3 col-lg-2 p-1 flex-column d-none',
      is_sidebar_hidden ? 'd-md-none' : 'd-md-flex'
    ]"
  >
    <div class="flex-grow-1 p-1 mt-2">
      <ProbaWorkflowsSidebar :items="menu_items" @close="is_sidebar_hidden = true" />
    </div>
  </div>

  <!-- Arrow Toggle -->
  <div
    v-if="!['view_all_user_forms', 'entity_application_overview','apply_for_jobs','entity_overview'].includes($route.name)"
    class="sidebar-toggle-arrow d-none d-md-flex align-items-center justify-content-center position-absolute btn-primary-dark rounded-circle shadow"
    :class="is_sidebar_hidden ? 'arrow-collapsed' : 'arrow-expanded'"
    @click="is_sidebar_hidden = !is_sidebar_hidden"
  >
    <i
      class="bi text-white fs-6"
      :class="is_sidebar_hidden ? 'bi-chevron-right' : 'bi-chevron-left'"
    ></i>
  </div>


  <!-- Main Content -->
  <div
    :class="[
      'proba-main-wrapper main-content-wrapper transition-all pt-3 vh-100 d-flex flex-column align-items-stretch pb-0',
      is_sidebar_hidden ? 'col-12' : 'col-9 col-lg-10',
      should_hide_layout_topbar_spacing ? 'proba-main-wrapper-no-topbar' : '',
      !should_show_layout_topbar ? 'proba-main-wrapper-no-topbar' : ''
    ]"
>
    <div :class="is_mobile ? 'proba-content-surface main-content overflow-auto px-2 py-1 mt-2 rounded-lg border d-flex flex-column' : 'proba-content-surface main-content overflow-auto glassy-bg px-2 rounded-lg border d-flex flex-column'">
      <div class="proba-page-slot d-flex flex-column flex-grow-1">
        <router-view class="mt-3"></router-view>
      </div>
    </div>
    <footer v-if="should_show_footer" class="proba-layout-footer border-top">
      <div class="proba-layout-footer-content">
        Powered by | <strong>Proba Workflows</strong>
      </div>
    </footer>
  </div>
    </div>

  <nav
    v-if="is_dwypd_recruitment_domain"
    class="dwypd-mobile-bottom-nav"
    aria-label="DWYPD mobile navigation"
  >
    <router-link
      v-for="item in dwypd_mobile_nav_items"
      :key="item.key"
      :to="get_dwypd_mobile_nav_target(item)"
      class="dwypd-mobile-bottom-nav-link"
      :class="{ 'is-active': is_dwypd_mobile_nav_active(item) }"
      :aria-current="is_dwypd_mobile_nav_active(item) ? 'page' : null"
      @click="set_dwypd_mobile_nav_active(item)"
    >
      <i :class="item.icon_class" aria-hidden="true"></i>
      <span>{{ item.label }}</span>
    </router-link>
  </nav>
</div>
